/* unplugin-vue-components disabled */import script from "./DefinitionFormModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DefinitionFormModal.vue?vue&type=script&setup=true&lang=js"

import "./DefinitionFormModal.vue?vue&type=style&index=0&id=246eee93&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-246eee93"]])

export default __exports__